<template>
    <div class="mt-4 mb-5">
        <div class="container mobile-container">
            <div class="payment-butoon mb-4">
                <base-button
                    tag="a"
                    v-for="(option, index) in options"
                    :type="active_option === option ? 'primary' : 'white'"
                    size="sm"
                    href="#"
                    role="button"
                    :class="active_option === option ? 'active' : ''"
                    :style="
                        active_option === option
                            ? 'pointer-events: none;'
                            : 'pointer-events: auto'
                    "
                    :key="index"
                    @click="activateOption(option)"
                    :name="$t('cart.recurrence.credit_card_brand')"
                    :error="errors.first($t('cart.recurrence.credit_card_brand'))"
                    aria-pressed="true"
                >
                    <span v-if="option === 'CreditCard'">
                        <svg class="mobile-card" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M11 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1z"/>
                            <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm13 2v5H1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm-1 9H2a1 1 0 0 1-1-1v-1h14v1a1 1 0 0 1-1 1z"/>
                        </svg>
                    </span>
                    <span v-else-if="option === 'Pix'">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 512 512" id="IconChangeColor" height="16" width="16">
                            <path d="M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.76C231.1-7.586 280.3-7.586 310.6 22.76L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.78L22.76 310.6C-7.586 280.3-7.586 231.1 22.76 200.8L80.78 142.7H112.6z"/>
                        </svg>
                    </span>
                    <span v-else-if="option === 'Boleto'">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16" viewBox="0 0 16 16">
                            <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5zM3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z"/>
                        </svg>
                    </span>
                        {{ option === 'CreditCard' ? $t('cart.credit_card') : option }}
                </base-button>
            </div>
            <div
                v-if="active_option === 'CreditCard'"
                ref="creditCard"
                class="d-flex flex-wrap justify-content-around credit-card-container"
            >
                <div class="col-12 col-md-12 col-lg-8 col-xl-11">
                    <card
                        type="secondary"
                        shadow
                        header-classes="bg-secondary"
                        body-classes="px-lg-12 py-lg-12"
                        class="border-0"
                        style="margin-bottom: 0"
                    >
                        <base-input
                            v-model="cardNumber"
                            @input="validateCardNumber"
                            v-validate="{required:true, length:16, regex: /^\d(?:\s?\d){15}$/}"
                            :name="$t('cart.recurrence.credit_card_number')"
                            :placeholder="$t('cart.recurrence.credit_card_number')"
                            :error="errors.first($t('cart.recurrence.credit_card_number'))"
                            required
                            type="text"
                            maxlength="16"
                        ></base-input>
                        <base-input
                            v-model="cardHolderName"
                            v-validate="'required'"
                            :name="$t('cart.recurrence.card_holder')"
                            :placeholder="$t('cart.recurrence.card_holder')"
                            :error="errors.first($t('cart.recurrence.card_holder'))"
                            required
                            type="text"
                        ></base-input>
                        <base-input
                            v-model="cardHolderCpf"
                            v-mask="'###.###.###-##'"
                            v-validate="{required:true, regex: /^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}$/}"
                            :name="$t('cart.recurrence.holder_cpf')"
                            :placeholder="$t('cart.recurrence.holder_cpf')"
                            :error="errors.first($t('cart.recurrence.holder_cpf'))"
                            required
                            type="text"
                        ></base-input>
                        <base-input
                            v-model="cardCvv"
                            v-validate="{ required: true, length:3}"
                            :name="$t('cart.recurrence.credit_card_cvv')"
                            :placeholder="$t('cart.recurrence.credit_card_cvv')"
                            :error="errors.first($t('cart.recurrence.credit_card_cvv'))"
                            v-mask="'###'"
                            @keyup="validate"
                            required
                            type="number"
                            @mouseover="flipCard"
                            @mouseout="resetCard"
                            @click="flipCard"
                        ></base-input>
                        <div class="row">
                            <div class="col-16 col-md-6">
                                <base-input
                                    v-model="cardExpirationMonth"
                                    v-validate="{ required: true, regex: /^(0?[1-9]|1[012])$/ }"
                                    :class="invalidMonth ? 'invalidMonthField' : ''"
                                    :name="$t('cart.recurrence.credit_card_expiration_month')"
                                    :placeholder="
                                        $t('cart.recurrence.credit_card_expiration_month')
                                    "
                                    :error="
                                        errors.first(
                                            $t('cart.recurrence.credit_card_expiration_month')
                                        )
                                    "
                                    required
                                    v-mask="'##'"
                                    type="text"
                                    @input="validateMonth"
                                ></base-input>
                                <span class="invalidField" v-if="invalidMonth">
                                    {{ $t('cart.date_expired') }}
                                </span>
                            </div>
                            <div class="col-16 col-md-6">
                                <base-input
                                    v-model="cardExpirationYear"
                                    v-validate="{ required: true, length: 4 }"
                                    :class="invalidMonth ? 'invalidMonthField' : ''"
                                    :name="$t('cart.recurrence.credit_card_expiration_year')"
                                    :placeholder="$t('cart.recurrence.credit_card_expiration_year')"
                                    :error="
                                        errors.first(
                                            $t('cart.recurrence.credit_card_expiration_year')
                                        )
                                    "
                                    required
                                    v-mask="'####'"
                                    type="text"
                                    @input="validateMonth"
                                ></base-input>
                                <span class="invalidField" v-if="invalidMonth">
                                    {{ $t('cart.date_expired') }}
                                </span>
                            </div>
                        </div>
                        <base-input
                            v-if="gateway && !!gateway.installments"
                            :name="$t('cart.recurrence.credit_card_expiration_year')"
                            :placeholder="$t('cart.recurrence.credit_card_expiration_year')"
                            required
                            title="Selecione o número de parcelas"
                            type="select"
                            @keyup="validate"
                        >
                            <select
                                class="form-control"
                                data-toggle="select"
                                v-model="installments"
                                v-if="gateway && gateway.slug === gateway.slug && !!gateway.installments"
                                title="Selecione o número de parcelas"
                                data-placeholder="Select a state"
                                @change="emitCardInfoChanged"
                            >
                                <option
                                    v-for="installment in gateway.installments.values"
                                    :key="installment.key"
                                    :value="installment.key"
                                >
                                    {{ printInstallment(installment, gateway.installments.increase_installment) }}
                                </option>
                            </select>
                        </base-input>
                    </card>
                </div>
                <div class="col-12 col-md-12 col-lg-4 col-xl-1 card-container">
                    <div class="front">
                        <span><svg xmlns="http://www.w3.org/2000/svg" style="transform: rotate(90deg);" fill="#ffffff" width="50" height="50" viewBox="0 0 16 16"> <path d="M2 1.5A1.5 1.5 0 0 1 3.5 0h7.086a1.5 1.5 0 0 1 1.06.44l1.915 1.914A1.5 1.5 0 0 1 14 3.414V14.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-13zM3.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V3.414a.5.5 0 0 0-.146-.353l-1.915-1.915A.5.5 0 0 0 10.586 1H3.5z"/> <path d="M5.5 4a.5.5 0 0 0-.5.5V6h2.5V4h-2zm3 0v2H11V4.5a.5.5 0 0 0-.5-.5h-2zM11 7H5v2h6V7zm0 3H8.5v2h2a.5.5 0 0 0 .5-.5V10zm-3.5 2v-2H5v1.5a.5.5 0 0 0 .5.5h2zM4 4.5A1.5 1.5 0 0 1 5.5 3h5A1.5 1.5 0 0 1 12 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 11.5v-7z"/> </svg></span>
                        <div class="card-number-box">
                            {{ formattedCardNumber || '#### #### #### ####' }}
                        </div>
                        <div class="flexbox">
                            <div class="box">
                                <span>CARD HOLDER</span>
                                <div class="card-holder-name">{{ cardHolderName }}</div>
                            </div>
                            <div class="box">
                                <span>EXPIRES</span>
                                <div class="expiration">
                                    <span class="exp-month">{{ cardExpirationMonth || '##'}}</span>
                                    /
                                    <span class="exp-year">{{ cardExpirationYear || '####'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="back">
                        <div class="stripe"></div>
                        <div class="box">
                            <span>CVV</span>
                            <div class="cvv-box">{{ cardCvv }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="active_option === 'Pix'"
                ref="pix"
                class="pix-card-cpf"
            >
                <div class="pix-icon-box">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="#32BCAD" viewBox="0 0 512 512" id="IconChangeColor" class="pix-icon">
                        <path d="M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.76C231.1-7.586 280.3-7.586 310.6 22.76L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.78L22.76 310.6C-7.586 280.3-7.586 231.1 22.76 200.8L80.78 142.7H112.6z"/>
                    </svg>
                </div>
                <div class="pix-text">
                    <div class="cpf-typed-text">
                        <h3>{{ $t('cart.pix_message') }}</h3>
                    </div>
                    <base-input
                        v-model="pixHolderCpf"
                        v-mask="'###.###.###-##'"
                        v-validate="{required:true, regex: /^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}$/}"
                        class="cpf-typed"
                        :name="$t('cart.recurrence.holder_cpf')"
                        :placeholder="$t('cart.recurrence.holder_cpf')"
                        :error="errors.first($t('cart.recurrence.holder_cpf'))"
                        required
                        type="text"
                    ></base-input>
                </div>
            </div>
            <div
                v-if="active_option === 'Boleto'"
                ref="boleto"
                class="billet-card-cpf"
            >
                <div class="billet-card">
                    <div class="billet-card-body">
                        <p>
                            {{ $t('cart.pagseguro_billet_message') }}
                        </p>
                        <base-input
                            v-model="billetHolderCpf"
                            v-mask="'###.###.###-##'"
                            v-validate="{required:true, regex: /^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}$/}"
                            class="cpf-typed"
                            :name="$t('cart.recurrence.holder_cpf')"
                            :placeholder="$t('cart.recurrence.holder_cpf')"
                            :error="errors.first($t('cart.recurrence.holder_cpf'))"
                            required
                            type="text"
                        ></base-input>
                        <p>
                            <strong>{{ $t('cart.obs') }}</strong> {{ $t('cart.obs_message') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Card from '../../argon/components/Cards/Card';
import BaseInput from '../../argon/components/Inputs/BaseInput';
import BaseButton from '../../argon/components/BaseButton';

export default {
    name: 'ChangePaymentPagSeguro',

    components: {
        Card,
        BaseInput,
        BaseButton,
    },

    props: {
        gateway: {
            type: Object,
            default: () => ({}),
        },
        pagseguroCreditCardOption: {
            type: Boolean,
            default: true,
            required: false,
        }
    },

    data() {
        return {
            active_option: '',
            cardNumber: '',
            cardHolderName: '',
            cardHolderCpf: '',
            cardExpirationMonth: '',
            cardExpirationYear: '',
            cardCvv: '',
            installments: 1,
            pixHolderCpf: '',
            billetHolderCpf: '',
            invalidMonth: false,
            customMessages: {
                min_value: 'O cartão está vencido.',
            },
        };
    },
    computed: {
        payment: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },

        formattedCardNumber() {
            const cardNumber = this.cardNumber.replace(/\s/g, '');
            const chunks = [];

            for (let i = 0; i < cardNumber.length; i += 4) {
                chunks.push(cardNumber.slice(i, i + 4));
            }

            return chunks.join(' ');
        },

        options() {
            const paymentMethods = this.gateway.payment_methods;
            const options = [];

            if (paymentMethods.credit_card && this.pagseguroCreditCardOption) {
                options.push('CreditCard');
            }

            if (paymentMethods.pix) {
                options.push('Pix');
            }

            if (paymentMethods.billet) {
                options.push('Boleto');
            }

            return options;
        },
    },
    methods: {
        validateMonth() {
            const currentYear = new Date().getFullYear();
            const currentMonth = new Date().getMonth() + 1;

            const inputYear = parseInt(this.cardExpirationYear, 10);
            const inputMonth = parseInt(this.cardExpirationMonth, 10);

            if (
                (this.cardExpirationYear.length === 4 && this.cardExpirationMonth.length === 2) && (inputYear < currentYear ||
                (inputYear === currentYear && inputMonth < currentMonth) ||
                inputMonth < 1 ||
                inputMonth > 12)
            ) {
                this.invalidMonth = true;
            } else {
                this.invalidMonth = false;
            }
        },

        validateCardNumber() {
            this.cardNumber = this.cardNumber.replace(/\D/g, '');
        },

        validateFields() {
            this.$validator.validateAll().then((result) => {
                if (result && this.invalidMonth === false) {
                    this.emitCardInfoChanged();
                    this.$emit('fieldsNotValid', false);
                } else {
                    this.$emit('fieldsNotValid', true);
                }
            });
        },

        printInstallment(installment, increaseInstallment) {
            const key = installment.key;

            if (key <= 1) {
                return `R$${ installment.value } à vista`
            } else {
                const value = (installment.value/key).toFixed(2);

                if (increaseInstallment > 1 && key >= increaseInstallment) {
                    return `${ key } vezes de R$${ value } com juros`;
                } else {
                    return `${ key } vezes de R$${ value } sem juros`;
                }
            }
        },

        emitCardInfoChanged() {
            if (this.active_option === 'CreditCard') {
                this.$emit('cardInfoChanged', {
                    cardNumber: this.cardNumber,
                    cardHolderName: this.cardHolderName,
                    cardHolderCpf: this.cardHolderCpf,
                    cardExpirationMonth: this.cardExpirationMonth,
                    cardExpirationYear: this.cardExpirationYear,
                    cardCvv: this.cardCvv,
                    installments: this.installments,
                });
            } else if (this.active_option === 'Pix') {
                this.$emit('cardInfoChanged', {
                    cardHolderCpf: this.pixHolderCpf,
                });
            } else if (this.active_option === 'Boleto') {
                this.$emit('cardInfoChanged', {
                    cardHolderCpf: this.billetHolderCpf,
                });
            }
        },

        flipCard() {
            document.querySelector('.front').style.transform = 'perspective(1000px) rotateY(-180deg)';
            document.querySelector('.back').style.transform = 'perspective(1000px) rotateY(0deg)';
        },

        resetCard() {
            document.querySelector('.front').style.transform = 'perspective(1000px) rotateY(0deg)';
            document.querySelector('.back').style.transform = 'perspective(1000px) rotateY(180deg)';
        },

        activateOption(option) {
            this.active_option = option;
            this.$emit('activateOption', option);
            // this.payment.brand = option;
        },

        validateCard() {
            this.validate();
            this.$emit('validateCard', this.payment);
        },

        validate() {
            this.$emit('validate');
        },
    },

    created() {
        const gatewayMethods = this.gateway.payment_methods;
        if (gatewayMethods.credit_card) {
            this.active_option = 'CreditCard';
        } else if (gatewayMethods.pix) {
            this.activateOption('Pix');
        } else if (gatewayMethods.billet) {
            this.activateOption('Boleto');
        }
    },
};
</script>

<style scoped>
span svg {
    display: flex;
    margin-right: 2px;
}

@media screen and (max-width: 768px) {
    span svg {
        width: 25px;
        height: 25px;
    }
}

@media (min-width: 769px) and (max-width: 1000px) {
    span svg {
        width: 30px;
        height: 30px;
    }
}

@media (max-width: 430px) {
    .mobile-container {
        padding-right: 0px !important;
        padding-left: 0px !important;
    }
}

.card-container {
    margin-top: 100px;
    display: flex;
    align-items: center;
    margin-bottom: 100px;
}

@media (min-width: 430px) and (max-width: 766px) {
    .card-container {
        margin-top: 110px;
        align-items: center;
    }
}

@media (min-width: 390px) and (max-width: 430px) {
    .card-container {
        margin-top: 108px;
        margin-bottom: 70px;
        margin-right: 70px;
    }
}

@media screen and (max-width: 390px) {
    .card-container {
        margin-top: 80px;
        margin-bottom: 70px;
        margin-right: 40px;
    }
}

@media screen and (min-width: 740px){
    .credit-card-container {
        width: 560px;
    }
}

.payment-butoon {
    display: flex;
    justify-content: center;
    width: 990px;
}

@media (min-width: 992px) and (max-width: 1200px) {
    .payment-butoon {
        width: 825px;
    }
}

@media screen and (max-width: 991px) {
    .payment-butoon {
        width: auto;
    }
}

.card-container .front{
    position: absolute;
    height: 250px;
    width: 400px;
    background: linear-gradient(45deg, blueviolet, deeppink);
    border-radius: 5px;
    backface-visibility: hidden;
    box-shadow: 0 15px 25px rgba(0, 0, 0, .2);
    padding: 20px;
    transform: perspective(1000px) rotateY(0deg);
    transition: transform .4s ease-out;
}

@media screen and (max-width: 400px) {
    .card-container .front {
        height: 125px;
        width: 200px;
        padding: 10px;
    }
}

.card-container .front .card-number-box {
    margin-top: 25px;
    padding: 30px 0;
    font-size: 22px;
    color: #fff;
}

@media screen and (max-width: 768px) {
    .card-container .front .card-number-box {
        padding: 15px 0;
        font-size: 20px;
    }
}

@media (min-width: 768px) and (max-width: 1000px) {
    .card-container .front .card-number-box {
        padding: 20px 0;
        font-size: 20px;
    }
}

.card-container .front .flexbox {
    display: flex;
}

.card-container .front .flexbox .box:nth-child(1) {
    margin-right: auto;
}

.card-container .front .flexbox .box{
    font-size: 15px;
    color: #fff;
}

@media screen and (max-width: 768px) {
    .card-container .front .flexbox .box {
        font-size: 11px;
    }
}

@media (min-width: 768px) and (max-width: 1000px) {
    .card-container .front .flexbox .box {
        font-size: 13px;
    }
}

.card-container .back {
    position: absolute;
    height: 250px;
    width: 400px;
    background: linear-gradient(45deg, blueviolet, deeppink);
    border-radius: 5px;
    backface-visibility: hidden;
    box-shadow: 0 15px 25px rgba(0, 0, 0, .2);
    padding: 20px 0;
    text-align: right;
    transform: perspective(1000px) rotateY(180deg);
    transition: transform .4s ease-out;
}

@media screen and (max-width: 400px) {
    .card-container .back {
        height: 125px;
        width: 200px;
        padding: 10px 0;
    }
}

.card-container .back .stripe {
    background: #000;
    width: 100%;
    margin: 10px 0;
    height: 50px;
}

@media screen and (max-width: 400px) {
    .card-container .back .stripe {
        margin: 5px 0;
        height: 25px;
    }
}

.card-container .back .box{
    padding: 0 20px;
    margin-top: 25px;
}

@media screen and (max-width: 400px) {
    .card-container .back .box {
        padding: 0 10px;
        margin-top: 12.5px;
    }
}

.card-container .back .box span{
    font-size: 15px;
    color: #fff;
}

@media screen and (max-width: 400px) {
    .card-container .back .box span {
        font-size: 7.5px;
    }
}

.card-container .back .box .cvv-box{
    height: 50px;
    padding: 10px;
    margin-top: 5px;
    color: #333;
    background: #fff;
    border-radius: 5px;
    width: 100%;
}

@media screen and (max-width: 400px) {
    .card-container .back .box .cvv-box {
        height: 25px;
        padding: 5px;
        margin-top: 2.5px;
    }
}

@media (min-width: 768px) and (max-width: 991px) {
    .card-container {
        margin-left: 140px;
    }
}

@media only screen and (max-width: 991px) {
    .card-container .front,
    .card-container .back {
        height: 200px;
        width: 360px;
    }
}

@media only screen and (max-width: 390px) {
    .card-container .front,
    .card-container .back {
        height: 170px;
        width: 300px;
    }
}

.cpf-typed-text {
    margin: 0.25rem;
}

.cpf-typed {
    width: -webkit-fill-available;
}

@media screen and (max-width: 500px) {
    .cpf-typed {
        margin-bottom: 0 !important;
    }
}

.pix-card-cpf {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.pix-icon-box {
    margin-right: 3vw;
}

.pix-icon {
    height: 8vw;
    width: 8vw;
}

@media screen and (max-width: 500px) {
    .pix-icon {
        height: 14vw;
        width: 14vw;
    }
}

.pix-text {
    width: 20vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

@media screen and (max-width: 500px) {
    .pix-text h3 {
        font-size: 0.8rem;
    }
}

@media screen and (max-width: 850px) {
    .pix-text {
        width: auto;
    }
}

.expiration {
    display: flex;
    justify-content: center;
}

@media only screen and (max-width: 1000px) {
    .mobile-card {
        height: 14px;
        width: 14px;
    }
}

.invalidField {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #fb6340;
}

.invalidMonthField {
    border: 1px solid #fb6340!important;
    border-radius: 0.25rem;
    margin-bottom: 0.25rem !important;
}

.invalidMonthField:focus {
    border: 1px solid #ffffff!important;
    border-radius: 0.25rem;
    margin-bottom: 0.25rem !important;
}

.billet-card {
    margin: 0 0 20px 170px;
    width: 675px;
    border: 1px solid #000000;
    border-radius: 6px;
    padding: 1.5rem;
}

@media screen and (max-width: 990px) {
    .billet-card {
        margin: 0 !important;
        width: fit-content !important;
    }
}

@media (min-width: 991px) and (max-width: 1199px) {
    .billet-card {
        margin: 0px 0 20px 45px;
        width: fit-content !important;
    }
}

.billet-card p {
    font-size: 1.2rem;
}
</style>
